import React from 'react';
import { ContainerTexto, Title, TitleContainer, Text, FixedAnchor } from '../styles';
import timeline from '../../../assets/img/ajuda/timeline.svg';
import timelineCompleta from '../../../assets/img/ajuda/timeline-completa.svg';
import { Anchor } from 'antd';

const Tracking: React.FC = () => {
  const { Link } = Anchor
  return (
    <>
      <ContainerTexto>
        <TitleContainer id="tracking-inicio">Visão geral do módulo Tracking:</TitleContainer>
        <Text>
          O módulo "Tracking" é um componente da aplicação web que permite rastrear e monitorar
          pedidos em tempo real. Ele fornece recursos para visualizar informações detalhadas sobre
          os pedidos, incluindo número da nota fiscal, status, cliente, cidade origem, cidade
          destino, veículo, data de embarque, localização do veículo, previsão de entrega. Também é
          possível baixar o canhoto da nota. Além disso, ao clicar no número da nota fiscal, serão
          exibidas as informações sobre os produtos que estão presentes na nota fiscal, incluindo
          código do produto, nome do produto, quantidade, unidade, peso e valor.
        </Text>
        <Text>
          O módulo também oferece filtros para pesquisar informações com base no número da nota
          fiscal, cidade do destinatário, nome do cliente e status. As entregas são classificadas em
          quatro status diferentes: "Aguardando expedição", "Em trânsito", "Chegada ao cliente" e
          "Entrega finalizada". Ao clicar no ícone de expansão , uma linha do tempo é mostrada,
          exibindo as etapas da entrega que são as mesmas do status.
        </Text>

        <div>
          <img src={timeline} alt="imagem mostrando um tipo de status" />
        </div>

        <Text>
          "Aguardando expedição": indica que o item ainda não foi enviado ou preparado para o envio.
          "Em trânsito": indica que o item já foi despachado e está a caminho do seu destino.
          "Chegada ao cliente": indica que o item chegou no endereço de entrega. "Entrega
          finalizada": indica que o item foi entregue com sucesso ao cliente e o processo de entrega
          foi concluído. A descrição de cada etapa pode ser visualizada ao passar o mouse por cima
          do status presente na timeline.
        </Text>

        <div>
          <img src={timelineCompleta} alt="imagem mostrando todos os tipos de status" />
        </div>

        <Title id="tracking-perfil">Perfis de Usuários:</Title>
        <Text>
          O sistema possui os seguintes perfis de usuários: Analista de Centro de Distribuição:
          poderá visualizar todos os monitoramentos da sua carteira de clientes.
        </Text>
        <Text>
          Administrador: poderá visualizar todos os monitoramentos relacionados ao centro de
          distribuição.
        </Text>

        <Title id="tracking-guia">Guia de Uso:</Title>

        <Text>
          Para usar o módulo de rastreamento, o usuário deve fazer login na aplicação web e navegar
          até a seção "Tracking". Dependendo do perfil do usuário, ele poderá visualizar todos os
          monitoramentos ou apenas os monitoramentos relacionados aos pedidos sob sua
          responsabilidade.
        </Text>
        <Text>
          O usuário pode visualizar informações detalhadas sobre cada pedido em andamento, incluindo
          número da nota fiscal, status, veículo, data de embarque, localização do veículo, previsão
          de entrega e um ícone para baixar o canhoto da nota. Ao clicar no número da nota fiscal,
          serão exibidas as informações detalhadas da nota fiscal que está em trânsito. Ao clicar no
          ícone de expansão, uma linha do tempo é mostrada, exibindo as etapas da entrega que são as
          mesmas do status.
        </Text>
        <Text>
          O módulo também oferece recursos para notificar os clientes automaticamente sobre o status
          do pedido e pesquisar informações com base no número da nota fiscal, cidade do
          destinatário e nome do cliente.
        </Text>

        <Title id="tracking-status">Status de Entrega:</Title>

        <Text>
          As entregas são classificadas em quatro status diferentes: "Aguardando expedição", "Em
          trânsito", "Chegada ao cliente" e "Entrega finalizada". O status de entrega é atualizado
          em tempo real e é exibido na seção de rastreamento do módulo. Ao clicar no ícone de
          expansão, uma linha do tempo é mostrada, exibindo as etapas da entrega que são as mesmas
          do status.
        </Text>
        <Text>
          Além disso, o módulo fornece recursos para notificar os clientes automaticamente sobre as
          atualizações do status de entrega. "Aguardando expedição": indica que o item ainda não foi
          enviado ou preparado para o envio. "Em trânsito": indica que o item já foi despachado e
          está a caminho do seu destino. "Chegada ao cliente": indica que o item chegou no endereço
          de entrega. "Entrega finalizada": indica que o item foi entregue com sucesso ao cliente e
          o processo de entrega foi concluído.
        </Text>

        <Title id="tracking-func">Funcionalidades:</Title>

        <Text>
          O módulo de rastreamento é uma ferramenta essencial para o gerenciamento de entregas e
          pedidos em tempo real. Algumas das principais funcionalidades do módulo incluem:
        </Text>
        <Text>
          Visualização detalhada do status de entrega, incluindo informações como número da nota
          fiscal, status, veículo, data de embarque, localização do veículo e previsão de entrega.
        </Text>
        <Text>
          Linha do tempo de entrega, mostrando as etapas da entrega em tempo real. Filtros para
          pesquisa de informações com base no número da nota fiscal, cidade do destinatário e nome
          do cliente.
        </Text>
      </ContainerTexto>

      <FixedAnchor>
        <Link title="Início" href='#tracking-inicio' />
        <Link title="Perfis de Usuários" href='#tracking-perfil' />
        <Link title="Guia de Uso" href='#tracking-guia' />
        <Link title="Status de Entrega" href='#tracking-status' />
        <Link title="Funcionalidades" href='#tracking-func' />
      </FixedAnchor>
    </>
  );
};

export default Tracking;
